export const isHTML = (str?: string | null): boolean => {
  try {
    if (!str) return false;
    const fragment = new DOMParser().parseFromString(str, "text/html");
    return fragment.body.children.length > 0;
  } catch (error) {
    return false;
  }
};
